import script from "./deals-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./deals-modal.vue?vue&type=script&setup=true&lang=js"

import "./deals-modal.vue?vue&type=style&index=0&id=6107af47&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6107af47"]])

export default __exports__